import { render, staticRenderFns } from "./SendMobileMessage.vue?vue&type=template&id=283f08a4&scoped=true"
import script from "./SendMobileMessage.vue?vue&type=script&lang=js"
export * from "./SendMobileMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f08a4",
  null
  
)

export default component.exports